import React, { Suspense, useContext, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import AppHeader from '../app-header/app-header'
import MetadataMiddleware from '../../pages/home/middleware/metadata-middleware'
import { routes, RouteType } from '../../routing'
import { Loader, LoaderMiddleware, useUserDetails } from '../../common'
import { Spin } from 'antd'
import { UserContext } from '../user-context/user-context-middleware'

import './app-layout.scss'
import AppFooter from '../app-footer/app-footer'
import Error404 from '../../pages/error-pages/error-404'

interface ComponentWithLoaderProps {
  children: JSX.Element
}
export type LogoutFunction = () => void

interface AppLayoutProps {
  children?: React.ReactNode
  logOut?: LogoutFunction
}

const ComponentWithLoader: React.FC<ComponentWithLoaderProps> = ({
  children,
}) => {
  return (
    <LoaderMiddleware>
      <Loader>{children}</Loader>
    </LoaderMiddleware>
  )
}

const AppLayout: React.FC<AppLayoutProps> = () => {
  const { isLoading, authData } = useUserDetails()
  const { setUserData } = useContext(UserContext)

  useEffect(() => {
    setUserData(authData)
  }, [authData])

  return !isLoading ? (
    <main>
      <MetadataMiddleware>
        <AppHeader />
        <section>
          <Suspense
            fallback={
              <div className="flex w-full justify-center items-end min-h-[40vh]">
                <Spin size="large" />
              </div>
            }
          >
            <Switch>
              {routes.map((route: RouteType) => (
                <Route
                  key={route.path}
                  path={route.path}
                  exact={route.exact}
                  component={() => (
                    <ComponentWithLoader>
                      <>{route.component}</>
                    </ComponentWithLoader>
                  )}
                />
              ))}
              <Route path="*" component={Error404} />
            </Switch>
          </Suspense>
        </section>
        <AppFooter />
      </MetadataMiddleware>
    </main>
  ) : (
    <div className="flex w-full justify-center items-end min-h-[40vh]">
      <Spin size="large" />
    </div>
  )
}

export default AppLayout
